import { HotelOutlined } from "@material-ui/icons";
import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import agent from "../api/agent";
import { Inscription, InscriptionFormValues } from "../models/Inscriptions";
import { DeleteInscriptionFormValues } from "../models/DeleteInscriptions";
import { useStore } from "./store";
import UserStore from "./userStore";
import Swal from "sweetalert2";

export default class InscriptionsStore {
  InscriptionRegistry = new Map<any, Inscription>();

  selectedInscription: Inscription | undefined = undefined;

  // selectedInscription: Inscription = {
  //     codigoTipoCuenta: 0,
  //     descripcion: "",
  //     creditoDebito: ""
  // };
  editMode = false;
  loading = false;
  loadingBoton = false;
  loadingInitial = false;
  inscrito = false;
  actualizado = false;

  constructor() {
    makeAutoObservable(this);
  }

  get InscriptionByCodigo() {
    return Array.from(this.InscriptionRegistry.values());
  }

  get groupedInscriptions() {
    return this.InscriptionRegistry;
  }

  update_SGPersonas = async (id: any) => {
    const fichaPersonal = await agent.SGPersonas.details(id);

    if (fichaPersonal.isUpdatedInfo === true) {
      this.actualizado = true;
    } else {
      this.actualizado = false;
    }
  };

  createInscription = async (Inscription: InscriptionFormValues) => {
    try {
      this.loadingBoton = true;
      this.inscrito = false;
      await agent.Inscriptions.create(Inscription).then((response) => {
        if (
          response == "El estudiante ya se encuentra asignado en este curso" ||
          response == "Cupo lleno" ||
          response == "Proceso de inscripcion fuera del rango de fechas" ||
          response ==
            "El curso al que se quiere asignar no cuenta con ediciones" ||
          response ==
            "Se encontro un error con la configuracion de Moodle contacta al administador" ||
          response == "Curso no encontrado" ||
          response ==
            "El curso al que se quiere asignar no cuenta con ediciones" ||
          response ==
            "Se encontro mas de una edicion activa para este curso, contacte al administrador" ||
          response == "La edicion ya no cuenta con cupo" ||
          response == "Solicitud de inscripcion no valida" ||
          response ==
            "El estudiante cuenta con una solicitud de preinscripcion pendiente de aprobacion" ||
          response == "Esta solicitud ya fue aprobada" ||
          response ==
            "La edicion a la cual esta realizando la solicitud no cuenta con configuracion de preinscripcion" ||
          response ==
            "La edicion a la cual esta realizando la solicitud no cuenta con la configuracion para inscripcion" ||
          response ==
            "El codigo institucional que esta ingresando es incorrecto" ||
          response ==
            "La edicion a la cual se quiere inscribir no cuenta con cuotas de inscripcion " ||
          response ==
            "El codigo institucional que esta ingresando es incorrecto o no pertenece a esta edición." ||
          response ==
            "Se ha llegado al límite de participantes permitidos para este convenio" ||
          response ==
            "El convenio aún se encuentra en fase de análisis, aún no puede realizar su inscripción." ||
          response ==
            "Ha ocurrido un error en su inscripción, por favor contacte al administrador."
        ) {
          toast.error(response);
          this.loadingBoton = false;
          Swal.close();
        } else if (
          response == "Registro creado exitosamente" ||
          response == "Preinscripcion solicitada exitosamente"
        ) {
          this.inscrito = true;
          this.loadingBoton = false;
          toast.success(response);
          Swal.close();
        }
      });
      runInAction(() => {
        this.selectedInscription = Inscription;
        this.loading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.loading = false;
      });
    }
  };

  deleteInscription = async (Inscription: DeleteInscriptionFormValues) => {
    this.loading = true;
    try {
      await agent.Inscriptions.delete(Inscription).then((response) => {
        if (
          response ===
          "Se ha cancelado la inscripcion del estudiante en el curso dado."
        ) {
          toast.success("Se ha desmatriculado al estudiante en el curso dado.");
          Swal.close();

          this.InscriptionRegistry.delete(Inscription.id);
        } else {
          toast.error("Ocurrió un error al eliminar los registros.");
          Swal.close();
        }
      });
      runInAction(() => (this.loading = false));
    } catch (error) {
      runInAction(() => (this.loading = false));
    }
  };
}
